// extracted by mini-css-extract-plugin
module.exports = {"workoutHeader":"WorkoutHeader_workoutHeader__2Pc4S","title":"WorkoutHeader_title__390a_","btn":"WorkoutHeader_btn__1xRrq"};